import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useBillableUnits} from '../hooks/useBillableUnits.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useBillableUnits();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};